<template>
  <div>
    <v-dialog v-model="dialog" max-width="700px" @click:outside="closeDialog">
      <v-card>
        <v-card-title class="footer">
          <v-row align="center">
            <v-col cols="auto">
              {{ product.SKU }}
              history
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pt-1">
              <v-icon @click="closeDialog">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ACTION</th>
                  <th class="text-left">NAME</th>
                  <th class="text-left">DATE</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in actions" :key="i">
                  <td>{{ item.action }}</td>
                  <td>{{ item.firstName }} {{ item.lastName }}</td>
                  <td>
                    {{ new Date(item.date).toLocaleString() }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ProductHistoryDialog",
  props: {},
  data: () => ({
    dialog: false,
    actions: [],
    product: {},
  }),

  methods: {
    showDialog(product) {
      this.product = product;

      this.actions = this.product.actions.sort((a, b) => {
        let dateA = new Date(a.date);
        let dateB = new Date(b.date);
        if (dateA.getTime() > dateB.getTime()) return -1;
        if (dateA.getTime() < dateB.getTime()) return 1;
        if (dateA.getTime() === dateB.getTime()) return 0;
      });
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
